import PageHead from "../Head";
import { withGuestSSR } from "@/lib/withGuestSSR";

import Context from "@/context/Context";
import ForgotPassword from "@/my_components/_ForgotPassword/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
      <Context>
        <PageHead title="Forgot Password | SmartTech Academy" />

        <ForgotPassword />
      </Context>
  );
};

export default ForgotPasswordPage;

export const getServerSideProps = withGuestSSR();
